import * as d3 from 'd3'
import { $, $$, round } from './util'
import Awesomplete from 'awesomplete'

import data from '../server/json/latest.json'

const isMobile = window.matchMedia('(max-width: 479px)').matches

const getQueryParameters = function() {
    return document.location.search.replace(/(^\?)/, '').split("&").map(function(n) { return n = n.split("="), this[n[0]] = n[1], this }.bind({}))[0];
}

const shorten = str => {
    return str.length <= 20 ? str : str.slice(0, 20) + '…'
}

let selected = null

let topVal = null

const ranges = {
    'Agriculture, forestry and fishing': [1, 3],
    'Mining': [5, 9],
    'Manufacturing': [10, 33],
    'Electricity and gas': [35, 35],
    'Water supply and sewerage': [36, 39],
    'Construction': [41, 43],
    'Wholesale and retail trade': [45, 47],
    'Transportation and storage': [49, 53],
    'Accommodation and food services': [55, 56],
    'Information and communication': [58, 63],
    'Finance and insurance': [64, 66],
    'Real estate': [68, 68],
    'Professional, scientific and technical activities': [69, 75],
    'Administrative activities': [77, 82],
    'Public administration and defence': [84, 84],
    'Education': [85, 85],
    'Health and social work': [86, 88],
    'Arts and entertainment': [90, 93],
    'Other services': [94, 96],
    'Households as employers': [97, 98],
    'Extraterritorial organisations and bodies': [99, 99]
}

const getSectors = row => {

    const codes = row.SicCodes.split(',').map(c => c.trim())
    return Array.from(new Set(codes.map(code => {

        if (code === '1') { return 'Public administration and defence' }

        const num = Number(code.slice(0, 2))
        return Object.keys(ranges).find(k => {
            const range = ranges[k]
            return range[0] <= num && num <= range[1]
        })
    })))
}

let refresh = ( ) => {}

const getMedian = row => Number(row.DiffMedianHourlyPercent)

const getNiceNumbers = (total, maxPercent, fractional) => {

    if (fractional) {

        const niceMax = Math.floor(maxPercent * 100) / 100
        const stepSize = niceMax / 5
        const range = d3.range(0, 5).map(i => i * stepSize * total)
        console.log(niceMax, stepSize, range)
        return range

    }

    if (total < 20) {

        return d3.range(0, total / 2, 5)

    } else {

        const stepSize = Math.floor(total * maxPercent / 5)

        const nearestFive = Math.floor(stepSize / 5) * 5 + ((stepSize % 5 === 0) ? 0 : 5)

        return d3.range(0, 5).map(i => i * nearestFive)

    }

}

const gapCol = '#ff7e00'
const advCol = '#2aadbc'

const drawHisto = data => {

    const svgEl = $('.gpg-chart')
    const width = svgEl.getBoundingClientRect().width
    const height = 400

    const options = {
        ticks : true,
        key : true,
        showLabels : true,
        absoluteNumbers: true
    }

    const padding = {
        top : 0,
        right : 0,
        bottom: 24,
        left : 0
    }

    const nBins = 71

    const barWidth = (width - padding.left - padding.right) / nBins

    const svg = d3.select(svgEl)
        .attr('width', width)
        .attr('height', height)

    const inputEl = $('.gpg-input')

    const awesome = new Awesomplete(inputEl, {
            list: data.map(d => d.EmployerName)
    })

    const close = d3.select($('.awesomplete'))
        .append("div")
        .style("display", "none")
        .classed("search", true)

        close.html(`<svg class="icon-cancel" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 30 30">
        <path d="m 8.2646211,7.64 -0.985372,0.992 6.8996289,7.5523 7.720992,6.739 0.821373,-0.8267 -6.899628,-7.5524 -7.5569939,-6.9042" fill="#fff"></path>
        <path d="m 7.2792491,21.64 0.985372,0.9854 7.5569939,-6.8977 6.899628,-7.5523 -0.985381,-0.992 -7.556984,6.9042 -6.8996289,7.5524" fill="#fff"></path>
        </svg>`)

        close.on("click", function(e) {
            close.style("display", "none");
            inputEl.value = "";
            d3.select(".label-g").remove();
        });

        d3.select(inputEl).on("keyup", function(e) {
            if (inputEl.value.length > 0) {
                close.style("display", "inline-block");
            } else {
                close.style("display", "none");
            }
        });

    const xDomain = [ -70, 70 ]
    
    const barDomain = [-61, 61]

    const xScale = d3.scaleLinear()
        .domain(xDomain)
        .range([padding.left, width - padding.right])

    const range = d3.range(barDomain[0], barDomain[1] + 1,
        (xDomain[1] - xDomain[0]) / (nBins - 1))

    const fullRange = [-2000].concat(range)

    const histo = d3.histogram()
        .domain([-2000, 2000])
        .thresholds(fullRange)

    const draw = data => {

    const mapped = data.map(getMedian)

    const bins = histo(mapped)

    const cScale = c => Math.abs(c) <= 1 ? '#dcdcdc' : (c > 0 ? gapCol : advCol)

    const maxPercent = d3.max(bins.map(b => b.length / mapped.length))

    const max = maxPercent * mapped.length

    const yScale = d3.scaleLinear()
        .domain([0, max])
        .range([0, height - padding.bottom - padding.top])

    const labels = getNiceNumbers(mapped.length, maxPercent, false)

    console.log(labels)

    topVal = labels.slice(-1)[0] > max ? labels.slice(-2)[0] : labels.slice(-1)[0]

    const yLineGroups = svg
        .selectAll('.gpg-y-line-g')
        .data(labels)
        .enter()
        .append('g')
    
        .attr('transform', d => `translate(0, ${height - padding.bottom - yScale(d)})`)
    
        yLineGroups
            .append('line')
            .attr('x1', padding.left)
            .attr('x2', width - padding.right)
            .attr('y1', 0)
            .attr('y2', 0)
            .attr('class', 'gpg-y-line')
    
        if (options.showLabels) {
    
            yLineGroups
                .append('text')
                .attr('x', padding.left)
                .attr('y', -4)
                .attr('class', 'gpg-y-label')
                .text((d, i) => {
    
                    return options.absoluteNumbers ? (i === labels.length - 1 ? d + ' companies' : d) : (i === labels.length - 1 ? round(d / mapped.length * 100) + '%' : round(d / mapped.length * 100))
                })
    
        }

    const bars = svg
        .selectAll('.histo-bar')
        .data(bins)
        .enter()
        .append('rect')
        .attr('width', barWidth - 0.5)
        .attr('height', d => yScale(d.length))
        .attr('x', (d, i) => i === 0 ? xScale(d.x1) - barWidth + 0.5 : xScale(d.x0) + 0.5)
        .attr('y', d => height - padding.bottom - yScale(d.length))
        .attr('fill', d => cScale((d.x1 + d.x0) / 2))
        .attr('class', 'histo-bar')
        .attr('id', d => d.x1)

        refresh = (company) => {

            const companyID = company.toLowerCase().replace(/ /g, "_");
            const row = data.filter(r => r.EmployerName.toLowerCase().replace(/ /g, "_") === companyID)[0]
            const sectors = getSectors(row)
            refreshSelect(sectors)
    
            const medianPayGap = row.DiffMedianHourlyPercent;
    
            const bin = bins.filter(d => d.x1 >= medianPayGap)[0];
    
            d3.select(".label-g").remove();
    
            const labelG = svg.append("g").classed("label-g", true);
    
            labelG.append("rect")
                .attr('width', barWidth - 2)
                .attr('height', 1.5)
                .attr('x', xScale(bin.x0) + 1)
                .attr('y', height - padding.bottom - yScale(bin.length))
                .attr('fill', 'none')
                .attr('stroke', 'black')
                .attr('stroke-width', '1.5px')
                // .attr('class', 'histo-bar')
    
            const tWhite = labelG.append("text")
            .text(isMobile || row.EmployerName.length > 40 ? shorten(row.EmployerName) : row.EmployerName )
            .attr("x", (xScale(Math.min(bin.x1, 63)) - xScale(bin.x0)) / 2 + xScale(bin.x0) - 2)
            .attr("y", (bin.x1 === 1) ? height - padding.bottom - yScale(bin.length) + 24 :  height - padding.bottom - yScale(bin.length) - 60)
            .classed("gpg-text-label", true)
            .classed('gap--white', true)
            .attr("dy", -4)
            .style("text-anchor", medianPayGap > 25 ? "end" : medianPayGap < -25 ? "start" : "middle")
            .attr("dx", medianPayGap > 40 ? "10" : "0")

            const t = labelG.append("text")
                .text(isMobile || row.EmployerName.length > 40 ? shorten(row.EmployerName) : row.EmployerName )
                .attr("x", (xScale(Math.min(bin.x1, 63)) - xScale(bin.x0)) / 2 + xScale(bin.x0) - 2)
                .attr("y", (bin.x1 === 1) ? height - padding.bottom - yScale(bin.length) + 24 :  height - padding.bottom - yScale(bin.length) - 60)
                .classed("gpg-text-label", true)
                .attr("dy", -4)
                .style("text-anchor", medianPayGap > 25 ? "end" : medianPayGap < -25 ? "start" : "middle")
                .attr("dx", medianPayGap > 40 ? "10" : "0")
    
            tWhite.append('tspan')
                .attr('class', row.DiffMedianHourlyPercent > 1 ? 'gpg-comp-perc gpg-comp-perc--gap gap--white' : ( row.DiffMedianHourlyPercent < -1 ? 'gpg-comp-perc gpg-comp-perc--adv' : 'gpg-comp-perc gpg-comp-perc--neutral gap--white' ))
                .text(round(row.DiffMedianHourlyPercent,1) + '%')
                .attr('dx', 4)

            t.append('tspan')
                .attr('class', row.DiffMedianHourlyPercent > 1 ? 'gpg-comp-perc gpg-comp-perc--gap' : ( row.DiffMedianHourlyPercent < -1 ? 'gpg-comp-perc gpg-comp-perc--adv' : 'gpg-comp-perc gpg-comp-perc--neutral' ))
                .text(round(row.DiffMedianHourlyPercent,1) + '%')
                .attr('dx', 4)
    
            labelG.append("line")
                .attr("x1", (xScale(Math.min(bin.x1, 63)) - xScale(bin.x0)) / 2 + xScale(bin.x0))
                .attr("x2", (xScale(Math.min(bin.x1, 63)) - xScale(bin.x0)) / 2 + xScale(bin.x0))
                .attr("y1", height - padding.bottom - yScale(bin.length) - 6)
                .attr("y2", height - padding.bottom - yScale(bin.length) - 56)
                .style("stroke", bin.x1 === 1 ? "none" : "#000")
                .style("stroke-width", "1.25px");
    
            labelG.append("g")
                .style("transform", `translate(${(xScale(bin.x1) - xScale(bin.x0))/2 + xScale(bin.x0) - 4}px, ${height - padding.bottom - yScale(bin.length) - 16}px)`)
    
        }

        const baseline = svg
        .append('line')
        .attr('x1', 0)
        .attr('x2', width)
        .attr('y1', height - padding.bottom)
        .attr('y2', height - padding.bottom)
        .attr('class', 'histo-base')

        if (options.ticks) {

            const ticks = svg
                .selectAll('.gpg-tick')
                .data([60, 40, 20, 0, -20, -40, -60])
                .enter()
                .append('g')
                .attr('transform', d => `translate(${xScale(d)}, ${height - padding.bottom })`)

            ticks
                .append('text')
                .text(d => d === 0 ? '0' : ([60, -60].indexOf(d) < 0 ? Math.abs(d) : '>' + Math.abs(round(d)) + '%'))
                .attr('y', 15)
                .attr('class', 'gpg-tick--label')

        }

        if (options.key) {

            const keyLeft = svg
                .append('g')
                .attr('transform', `translate(${isMobile ? 0 : 30}, ${height - padding.bottom - yScale(topVal) + 28 })`)
    
            keyLeft
                .append('text')
                .attr('x', 17)
                .attr('y', -8)
                .text('Companies that pay')
                .attr('class', 'gpg-key gpg-key--left')
    
            keyLeft
                .append('text')
                .attr('x', 17)
                .attr('y', isMobile ? 11 : 13)
                .text('women more')
                .attr('class', 'gpg-key gpg-key--left')
    
            const triLeft = keyLeft
                .append('path')
                .attr('d', 'M 12,1 L 0,5.5 L 12,11')
                .attr('class', 'gpg-tri gpg-tri--left')
    
            const keyRight = svg
                .append('g')
                .attr('transform', `translate(${isMobile ? width - 12 : width - 12 - 30}, ${height - padding.bottom - yScale(topVal) + 28 })`)
    
            keyRight
                .append('text')
                .attr('x', -5)
                .attr('y', -8)
                .text('Companies that pay')
                .attr('class', 'gpg-key gpg-key--right')
    
            keyRight
                .append('text')
                .attr('x', -5)
                .attr('y', isMobile ? 11 : 13)
                .text('women less')
                .attr('class', 'gpg-key gpg-key--right')
    
            const triRight = keyRight
                .append('path')
                .attr('d', 'M 0,1 L 12,5.5 L 0,11')
                .attr('class', 'gpg-tri gpg-tri--right')
    
        }


    }

    // actual histo draw END

    draw(data)

    
    if(window.resize) {
        window.resize()
    }

    // INTERACTIVE SHIZZLE

    const refreshSelect = sectors => {

        console.log('Sectors:', sectors)

        const select = $('.gpg-select')
        const options = $$('.gpg-select option')

        select.value = 'all'

        $('.search').style.display = 'inline-block'
        
        options.forEach((o, i) => {

            if(i === 0 || sectors.indexOf(o.value) >= 0) {
                o.classList.remove('gpg-option--hidden')
            }
            else {
                o.classList.add('gpg-option--hidden')
            }
        })


    }

    const input = $('.gpg-input')

    const params = getQueryParameters()
    if(params.highlight) {

        const hl = decodeURIComponent(params.highlight)

        const row = data.filter(r => r.EmployerName.toLowerCase().replace(/ /g, "_") === hl.toLowerCase().replace(/ /g, "_"))[0]
        if(row) {
            input.value = row.EmployerName
            refresh(hl)
        } else {
            console.log("couldn't parse employer from url params", params, hl)
        }

    }

    document.addEventListener("awesomplete-selectcomplete", function(e) {

        const company = e.text.label
        refresh(company)
    });

}

const params = getQueryParameters()

if(params.publicOnly && String(params.publicOnly).toLowerCase() !== 'false') {
    $('.gpg-title').innerHTML = 'Pay gaps in <strong>public administration and defence</strong>'
    drawHisto(data.filter( row => getSectors(row).indexOf('Public administration and defence') >= 0 ))
}

else {
    drawHisto(data)
}